<template lang="pug">
div 
  section.about__section--black
    .about__section
      .about__section--intro
        h1 Magical tools for visual storytelling.
        p Flixel is a Toronto-based startup that loves visual storytelling. Our software tools enable photographers, videographers and digital marketers to tell mesmerizing stories using a new visual medium known as cinemagraphs.
        p We’re best known for Cinemagraph Pro. It’s a 2014 Apple Design Award winner that is used around the world by a fast-growing community of professional Flixel Artists to create cinemagraphs. Together, we help advance cinemagraphs as the medium that is transforming visual storytelling across digital advertising, social media and photography.

  section.about__section
      .about__content--award
        .award__item
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/awards/awardada@2x.png 2x, https://cdn.flixel.com/static/static-web/awards/awardada.png 1x')
        .award__item
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/awards/awardappstore@2x.png 2x, https://cdn.flixel.com/static/static-web/awards/awardappstore.png 1x')
        .award__item
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/awards/awarddigi@2x.png 2x, https://cdn.flixel.com/static/static-web/awards/awarddigi.png 1x')
        .award__item
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/awards/awardstartupfest@2x.png 2x, https://cdn.flixel.com/static/static-web/awards/awardstartupfest.png 1x')

  section.about__section
      .about__content
        .about__content--title
          h1 Our Story
        .about__content--text
          p Founded in 2011, Flixel has come a long way since our days as a social networking app that made GIFs. We create professional tools that are easy to use, save time and complement workflows for all storytellers. That’s why Cinemagraph Pro for macOS and iOS are the world’s favourite ways to create and share cinemagraphs.

          p We enhance creation experiences. We offer Flixel Cloud, a web platform for hosting and streaming cinemagraphs in HD, and Persecond, a timelapse app. We were honored with the Apple Design Award for Cinemagraph Pro for macOS in 2014 and Best of 2014 in the App Store.

          p We work with other storytellers to spread the excitement of cinemagraph creation everywhere. In 2013, the hit TV show America’s Next Top Model featured Cinemagraph Pro during Cycle 20. We count Tyra Banks, creator and executive producer of Top Model, as one of our investors. In 2016, Flixel became one of the first partners for Facebook’s Profile Expression Kit, allowing users to show off their personalities in custom cinemagraph profile videos.

          p We also help brands tell better stories by bringing the cinemagraph experience to life. Our in-house production team, Flixel Studios, produces custom campaigns, live activations and more for leading brands around the world, including A&E, British Airways, Disney, Facebook, HBO, Marriott, Mashable, Mercedes, TED Conference and Microsoft.
        .about__video
          .fluid__video
            iframe(data-src="https://www.youtube.com/embed/__gRRRjhhaw" frameborder="0" allow='autoplay')

  section.about__section
    .about__locations
      .location__item
        img.lazy.location__item--pic(data-srcset='https://cdn.flixel.com/static/static-web/about/officepictures/toronto@2x.png 2x, https://cdn.flixel.com/static/static-web/about/officepictures/toronto.png 1x')
        h2 Toronto
        .location__item--desc
          p The Flixel team is a remote workforce. We work how, when, and where it allows us to be focused to do our best work. Much of the core team is based in Toronto, where we often get together for "meetings" (aka lunch).
        .location__item--address
          p Flixel Photos Inc.
          p 488 Wellington Street West, Suite 304
          p Toronto, ON
          p Canada
          p M5V 1E3
      .location__item
        img.lazy.location__item--pic(data-srcset='https://cdn.flixel.com/static/static-web/about/officepictures/new-york@2x.png 2x, https://cdn.flixel.com/static/static-web/about/officepictures/new-york.png 1x')
        h2 New York
        .location__item--desc
          p The Flixel Studios satellite office is in the heart of the advertising capital of the world, Manhattan, New York. Connect with Flixel Studios to learn how to bring your campaigns to life.
        .location__item--address
          p Flixel Inc.
          p c/o Grand Central Tech
          p 335 Madison Avenue
          p Floor 4
          p New York, NY 10017
          p USA

  section.about__section
    .about__funding
      .funding__item
        img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/about/supportedby/500startups@2x.png 2x, https://cdn.flixel.com/static/static-web/about/supportedby/500startups.png 1x')
      .funding__item
        img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/about/supportedby/mantella@2x.png 2x, https://cdn.flixel.com/static/static-web/about/supportedby/mantella.png 1x')
      .funding__item
        img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/about/supportedby/canadamediafund@2x.png 2x, https://cdn.flixel.com/static/static-web/about/supportedby/canadamediafund.png 1x')
      .funding__item
        img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/about/supportedby/extremeventurepartners@2x.png 2x, https://cdn.flixel.com/static/static-web/about/supportedby/extremeventurepartners.png 1x')
      .funding__item
        img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/about/supportedby/NBIF@2x.png 2x, https://cdn.flixel.com/static/static-web/about/supportedby/NBIF.png 1x')
      .funding__item
        img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/about/supportedby/BDC@2x.png 2x, https://cdn.flixel.com/static/static-web/about/supportedby/BDC.png 1x')
</template>

<script>
export default {
  name: 'Company',
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Company.vue